<script setup lang="ts">
    import { Employee } from '@/types';
    import DataTableActions from '@/components/datatable/DataTableActions.vue';
    import ExportEmployeeChanges from '@/components/employees/ExportEmployeeChanges.vue';
    import OpenEmployeeChanges from '@/components/employees/OpenEmployeeChanges.vue';
    import EmployeeChangesRegistrated from '@/components/employees/EmployeeChangesRegistrated.vue';
    import EmployeeSalaryChangeRegistrated from '@/components/employees/EmployeeSalaryChangeRegistrated.vue';

    defineProps<{
        employee: Employee;
    }>();
</script>

<template>
    <DataTableActions :data="employee">
        <OpenEmployeeChanges :employee="employee" />
        <ExportEmployeeChanges :employee="employee" />
        <EmployeeChangesRegistrated v-if="employee.log && !employee.log.changes_noted" />
        <EmployeeSalaryChangeRegistrated
            v-if="employee.unnoted_salary"
            :unnoted-salary="employee.unnoted_salary"
        />
    </DataTableActions>
</template>
